import { VApp } from 'vuetify/lib/components/VApp';
import { VResponsive } from 'vuetify/lib/components/VResponsive';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VApp,[_c(VResponsive,[(_vm.theme === 1)?_c('detail-theme0001',{attrs:{"detail-product":_vm.detailproduct}}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }